export const SURVEY_TYPES = {
  RESIDENT_PORTAL_MAINTENANCE_SURVEY: 23,
  RESIDENT_PORTAL_MOVE_OUT_SURVEY: 24,
  RESIDENT_PORTAL_MOVE_IN_SURVEY: 25,
}

export const DOCUMENT_TYPES = {
  WEB_PAGE: 1,
  CUSTOM_FORM: 2,
}

export const CUSTOM_DOCUMENT = {
  WEB_PAGE: 1,
  CUSTOM_FORM: 5,
  RESIDENT_PORTAL_SURVEY_FORM: 7,
  RESIDENT_PORTAL_MAINTENANCE_SURVEY: 23,
  RESIDENT_PORTAL_MOVE_OUT_SURVEY: 24,
  RESIDENT_PORTAL_MOVE_IN_SURVEY: 25,
}

export const DOCUMENT_BANNER = {
  DOCUMENT_BANNER_TEXT: __(
    'Invoices can be found under the Payments > Ledger > Invoices.',
  ),
  DOCUMENT_BANNER_HIDE_TIME: 10000,
}
